module.exports = "https://d1tntvpcrzvon2.cloudfront.net/vwassets/new2/_next/static/images/marquee_mobile2-4d8de84b73e376ff8a1c87132295a6ec.jpg";